export default "__VITE_ASSET__C2oLOQmP__"